<template>
    <div class="button"
        :class="{'success': success, 'back': back, 'disabled': disabled, 'border': border}"
         @click.prevent="clickAction"
         @keydown.enter.stop="clickAction"
         tabindex="0"
    >
        <div v-if="back" class="icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8C16 7.44772 15.5523 7 15 7H3.83L8.71039 2.11961C9.10189 1.72811 9.10037 1.09262 8.70749 0.702509C8.31657 0.314339 7.68494 0.315064 7.29539 0.704613L0.707106 7.29289C0.316582 7.68342 0.316583 8.31658 0.707107 8.70711L7.29468 15.2947C7.68422 15.6842 8.31578 15.6842 8.70532 15.2947C9.0946 14.9054 9.09489 14.2743 8.70595 13.8847L3.83 9H15C15.5523 9 16 8.55229 16 8Z" fill="#5CD69B"/>
            </svg>
        </div>
        <div class="textButton" v-html="buttonText"></div>
    </div>
</template>

<script>
    export default {
        name: "custom-button",
        props: {
            buttonText: String,
            success: Boolean,
            back: Boolean,
            border: Boolean,
            action: Function,
            disabled: Boolean,
        },
        methods: {
            clickAction: function (event) {
                if (this.disabled )
                    return;
                this.$emit('click', event);
                if (this.action)
                    this.action();
                else if (this.link)
                    this.$router.push(this.link)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/config.scss";
    .button {
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 24px;
        cursor: pointer;
        padding: 0 1em 1px;
        box-sizing: border-box;
        &.success {
            background: $success-button-color;
            width: 100%;
            .textButton { color: #FFFFFF;}
        }
        &.back {
            justify-content: left;
            padding: 0;
            .icon {
                margin: 0 12px 0 4px ;
                svg { vertical-align: middle;}
            }
            &:hover .textButton,
            &:focus .textButton{
                color: #2ed65b;
                outline: none;
            }
        }
        &.border {
            border: 1px solid #87D1C0;
        }
        .textButton {
            color: #5CD69B;
        }
        &.disabled {
            cursor: default;
            &.success {
                background: #D7F2EC;
            }
            .textButton { color: #B5E3D8;}
            &:hover,
            &:focus {
                cursor: default;
                .textButton { color: #B5E3D8;}
            }
            .icon {
                opacity: .5;
            }
        }
        &.success:not(.disabled):hover,
        &.success:not(.disabled):focus {
            background: $success-hover-button-color;
        }
        &:hover,
        &:focus {
            outline: none;
        }
    }

    @media (max-width: 300px) {
        .textButton {
            font-weight: 500;
            font-size: 13px;
            line-height: 8px;
        }
        .button {
            height: 46px;
        }

    }
    @media (min-width: 301px) and (max-width: 600px) {
        .textButton {
            font-weight: 500;
            font-size: 17px;
            line-height: 22px;
        }
        .button { height: 46px; }
    }
    @media (min-width: 601px) and (max-width: 750px) {
        .textButton {
            font-weight: 500;
            font-size: 17px;
            line-height: 22px;
        }
        .button { height: 52px;}

    }
    @media (min-width: 751px) {
        .textButton {
            font-weight: 500;
            font-size: 17px;
            line-height: 22px;
        }
        .button { height: 52px; }
    }
</style>